import React from "react";
import { Map, Marker, TileLayer } from "react-leaflet";

function ScorecardCollegeMap({ coordinates }) {
  return (

      <Map center={[ coordinates[0]-.003, coordinates[1] ]} zoom={13} zoomControl={false}>
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        />
        <Marker position={coordinates}></Marker>
      </Map>

  );
}

export default ScorecardCollegeMap;
